import {Component, input, model, OnInit, ViewChild} from '@angular/core';
import {actionType} from "../../types/types";
import {FirebaseEventEnum} from "../../enum/firebase-event.enum";
import {FirebaseService} from "../../service/firebase.service";
import {Pharmacy} from "../../model/pharmacy.model";
import {CommonService} from "../../service/common.service";
import {IonSelect} from "@ionic/angular";

@Component({
  selector: 'app-pharmacy-actions',
  templateUrl: './pharmacy-actions.component.html',
  styleUrls: ['./pharmacy-actions.component.scss'],
})
export class PharmacyActionsComponent implements OnInit {

  @ViewChild("actions") actions: IonSelect;

  pharmacy = model<Pharmacy>();

  constructor(private firebaseService: FirebaseService,
              private commonService: CommonService) {
  }

  ngOnInit() {
  }


  open(pharmacy?: Pharmacy) {

    if(pharmacy) {
      this.pharmacy.set(pharmacy);
    }

    this.actions.open();
  }

  onSelectChange(event) {
    const action: actionType = event.detail.value;
    if (action == 'phone') {

      this.firebaseService.logEvent(FirebaseEventEnum.CLICK_PHARM_PHONE, {
        pharm_name: this.pharmacy.name
      });

      this.commonService.initiateCall(this.pharmacy().phoneNumber);
    } else {

      this.firebaseService.logEvent(FirebaseEventEnum.CLICK_PHARM_ADDRESS, {
        pharm_name: this.pharmacy.name
      });

      this.commonService.openGoogleMaps(this.pharmacy().coords.longitude, this.pharmacy().coords.latitude)
    }
  }
}
